/**
 * Handles setting and removing a filter value to the sites url
 * Since filters are reused and not inherited, we created a side function
 */

/**
 * Get query params from url
 */
const getQueryParams = () => {
    return window.location.search
        .slice(1)
        .split('&')
        .reduce((params, pair) => {
            let [key, value] = pair.split('=');
            params[decodeURIComponent(key)] = decodeURIComponent(value);
            return params;
        }, {});
};

/**
 * Build query string from params object
 */
const buildQueryParams = params => {
    let values = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    return `?${values};`;
};

/**
 * Parses a value from a url query stirng
 */
const parseValue = value => {
    if (value.includes(';')) {
        return value.split(';');
    }

    if (value.startsWith('b64:')) {
        return atob(value.replace('b64:', ''));
    }

    return value;
};

/**
 * Stringifies a value to url form
 */
const stringifyValue = value => {
    if (value instanceof Array) {
        return encodeURIComponent(value.join(';'));
    }

    if (value instanceof Object) {
        return encodeURIComponent(btoa(JSON.stringify(value)));
    }

    return encodeURIComponent(value);
};

/**
 * Try to fetch a value from query params
 */
export const getFromQueryParams = name => {
    let queryParams = getQueryParams();
    if (!queryParams[name]) {
        return undefined;
    }

    // parse
    return parseValue(queryParams[name]);
};

/**
 * Append a value to the dom's query string
 */
export const appendValueToQueryString = (name, value) => {
    let queryParams = getQueryParams();
    queryParams[name] = stringifyValue(value);
    let string = buildQueryParams(queryParams);
    window.history.pushState(null, null, string);
};

/**
 * Removes value from queryString
 */
export const removeFromQueryParams = name => {
    const params = getQueryParams();
    delete params[name];
    let string = buildQueryParams(params);
    window.history.pushState(null, null, string);
};
